import type { InternalAxiosRequestConfig } from 'axios'

import { getAnonSessionId } from '@/data/api/anonSession'
import { hasValidEntraAccessToken } from '@/data/api/token'

/** Send X-Anon-Session for guest traffic only (no Entra JWT). */
export const anonSessionInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (!hasValidEntraAccessToken()) {
    config.headers['X-Anon-Session'] = getAnonSessionId()
  }

  return config
}
